import classNames from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';
import { Heading } from 'yoso';
import { Exclamation2 } from '~/components/Icon/Exclamation2';
import styles from '~/components/Message/Message.module.scss';
import './ErrorMessage.scss';

export type ErrorMessageProps = PropsWithChildren<{
  className?: string;
  icon?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
}>;
export const ErrorMessage = ({
  className,
  icon = <Exclamation2 className={styles.icon} width="100" height="100" />,
  title,
  description,
  children,
}: ErrorMessageProps) => (
  <div className={classNames(styles.root, 'error-message', className)}>
    <div className={classNames(styles.header, 'error-message-header')}>{icon}</div>
    <div className={classNames(styles.body, 'error-message-body')}>
      <Heading level={4} className={classNames(styles.title, 'error-message-title')}>
        {title}
      </Heading>
      <p className={classNames(styles.description, 'error-message-description')}>{description}</p>
      {children}
    </div>
  </div>
);
